import React from "react";
import Headline from "./Headline";
import PostsApi from "../../api-services/posts-api.service";
import { Link, useParams } from "react-router-dom";
import { notification } from "antd";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import HomeLink from "../../widgets/HomeLink";

const bannerPath = '/iceholidays-assets/images/blog.png';
const categoryLabel = {
  "pdpa": "PDPA",
  "terms_and_condition": "Terms & Conditions",
  "privacy_policy": "Privacy Policy",
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()}/>;
}

class FooterStaticPage extends React.Component <{params, searchParams}>  {
  postsApi = new PostsApi;

  state = {
    header: "",
    breadcrumbs:[],
    type: this.props.params['type'],
    blog: {title: "", thumbnail: "", content: ""},
  }

  componentDidMount() {
    this.getPosts(this.state.type);    
  }

  componentDidUpdate(prevProps: Readonly<{ params: any; }>, prevState: Readonly<{}>, snapshot?: any): void {    
    const type = this.props.params['type'];
    if(prevProps.params.type != type){
      this.getPosts(type);
    }
  }

  getPosts(type){
    const header = categoryLabel[type];
    const breadcrumbs = [
      { title: <HomeLink/>},
      { title: `${header}`},
    ];

    this.setState({breadcrumbs, header})

    this.postsApi.getPosts(type)
    .then(({posts}) => {
      if(posts.length > 0){
        this.setState({blog: posts[0]})
      }
    })
    .catch(error => {
      notification.error({ message: `An error occured while loading ${header}.`});
    });
  }


  render(){
    const {blog, header, breadcrumbs} = this.state;
    return blog && (
      <div id="static-page" className="footer-links-page">
        <Headline showSearch={false} bannerImage={blog.thumbnail || bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            {header}
          </span>
        </Headline>

        <div className="footer-links-show-page_body">
          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
        </div>
      </div>
    )
  }
}


export default withParams(FooterStaticPage);